import { InjectionToken } from '@angular/core';

import { ColorAccessibility, DisplayConfiguration } from './types';

export const BUTTON_DISPLAY_CONFIG = new InjectionToken<DisplayConfiguration>(
  'DisplayConfiguration',
);
export const BUTTON_COLOR_ACCESSIBILITY =
  new InjectionToken<ColorAccessibility>('ColorAccessibility');
